import { useQuery } from "@tanstack/react-query";
import { useApi } from "src/contexts/api.context";
import { useActiveParams } from "src/hooks/useActiveParams";
import type { GeoPoint } from "src/types/GeoPoint";

interface Project {
  id: string;
  name: string;
  areaOfInterest: GeoPoint | null;
  createdAt: string;
  updatedAt: string;
  notes: string | null;
  designsCount: number;
  scenarios: {
    id: string;
    name: string;
  }[];
}

export function useActiveProjectQuery() {
  const api = useApi();
  const { projectId } = useActiveParams();

  return useQuery({
    queryKey: [projectId],
    keepPreviousData: true,
    staleTime: Infinity,
    queryFn: async (): Promise<Project | null> => {
      if (!projectId) return null;
      const [project, scenarios] = await Promise.all([
        api.GetProject({ projectId }),
        api.GetScenarioCollection({ projectId }),
      ]);
      if (!project || !scenarios) return null;
      return {
        id: project.id,
        name: project.label,
        areaOfInterest: project.area_of_interest?.point ?? null,
        createdAt: project.created_at,
        updatedAt: project.updated_at,
        notes: project.notes,
        designsCount: 0,
        scenarios: scenarios.results.map((site) => ({
          id: site.id,
          name: "location name here, am i needed?",
        })),
      };
    },
  });
}
